import { render } from "./Page-Fac.vue?vue&type=template&id=ff80c00a&scoped=true"
import script from "./Page-Fac.vue?vue&type=script&lang=js"
export * from "./Page-Fac.vue?vue&type=script&lang=js"

import "./Page-Fac.vue?vue&type=style&index=0&id=ff80c00a&scoped=true&lang=css"
import "./Page-Fac.vue?vue&type=style&index=1&id=ff80c00a&scoped=true&lang=css"
import "./Page-Fac.vue?vue&type=style&index=2&id=ff80c00a&scoped=true&lang=css"
import "./Page-Fac.vue?vue&type=style&index=3&id=ff80c00a&scoped=true&lang=css"
import "./Page-Fac.vue?vue&type=style&index=4&id=ff80c00a&scoped=true&lang=css"
import "./Page-Fac.vue?vue&type=style&index=5&id=ff80c00a&scoped=true&lang=css"
import "./Page-Fac.vue?vue&type=style&index=6&id=ff80c00a&scoped=true&lang=css"
import "./Page-Fac.vue?vue&type=style&index=7&id=ff80c00a&scoped=true&lang=css"
import "./Page-Fac.vue?vue&type=style&index=8&id=ff80c00a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.22_vue@3.5.22_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff80c00a"]])

export default __exports__